import { Component } from "react";
import { message, PageHeader, Spin, Upload, Row, Col, Alert, Switch, Select } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { TableItem, ButtonItem } from "../../../../Components/Items";
import TableItemDinamico from "../../../../Components/TableItemDinamico";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { encodeId, decodeId } from "../../../../Components/idEncoder";
import ModalProgreso from "../../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../../Components/seguirProcesoMasivo";

const CAMPO_TEXTO = {
  "Descripcion Equivalencia": "descripcion",
  "Clave Equivalencia": "clave",
  Presentacion: "presentacion",
};

const CAMPO_BOOL = {
  Venta: "venta",
  VentaOnline: "ventaOnline",
};

const nombreCliente = (c) => {
  if (!c) return "";
  if (c.persona) return c.razonSocial || "";
  return [c.nombre, c.apellidoPaterno, c.apellidoMaterno].filter(Boolean).join(" ").trim();
};

const CATALOGOS_CONFIG = [
  { col: "Unidad Equivalencia", campo: "unidadId", stateKey: "todasUnidades", getNombre: (u) => u?.nombre || "" },
  { col: "Cliente", campo: "clienteId", stateKey: "todosClientes", getNombre: nombreCliente },
];

const COLS_REQUERIDAS = new Set(["Descripcion Equivalencia", "Unidad Equivalencia", "Factor", "Venta"]);

const COLUMNAS_INSUMO_BASE = ["Clave Insumo Base", "Descripcion Insumo Base", "Unidad Insumo Base"];

const COLUMNAS_FIJAS = [
  "ID",
  ...COLUMNAS_INSUMO_BASE,
  "Factor",
  "Clave Equivalencia",
  "Descripcion Equivalencia",
  "Unidad Equivalencia",
  "Venta",
  "VentaOnline",
  "Cliente",
  "Presentacion",
];

const GRUPOS = [
  { key: "id", label: "ID", color: "595959", columnas: ["ID"] },
  { key: "insumoBase", label: "Insumo Base", color: "1890FF", columnas: COLUMNAS_INSUMO_BASE },
  { key: "factor", label: "Factor", color: "52C41A", columnas: ["Factor"] },
  {
    key: "equivalencia",
    label: "Equivalencia",
    color: "595959",
    columnas: [
      "Clave Equivalencia",
      "Descripcion Equivalencia",
      "Unidad Equivalencia",
      "Venta",
      "VentaOnline",
      "Cliente",
      "Presentacion",
    ],
  },
  { key: "listaPrecios", label: "Lista de Precios", color: "FA8C16", columnas: [] },
];

const columnasDeGrupo = (g, { todasPrecios }) => {
  if (g.key === "listaPrecios") {
    return (todasPrecios || [])
      .map((p) => `Precio ${(p.nombre || "").trim()}`)
      .filter((c) => c !== "Precio ");
  }
  return g.columnas;
};

const grupoDeColumna = (col, state) => GRUPOS.find((g) => columnasDeGrupo(g, state).includes(col)) || null;

const EJEMPLOS_POR_COLUMNA = {
  ID: ["(vacío = fila nueva)", "No modificar si ya trae un valor"],
  "Clave Insumo Base": ["TOR-HEX-12", "INS-0001"],
  "Descripcion Insumo Base": ["(informativo, no se usa si ya llenó Clave Insumo Base)", "Tornillo hexagonal 1/2 pulgada"],
  "Unidad Insumo Base": ["(informativo, no se guarda)", "Pieza"],
  Factor: ["12", "10", "1"],
  "Clave Equivalencia": ["TOR-HEX-12-CJA", "(vacío = hereda la clave del insumo)"],
  "Descripcion Equivalencia": ["Caja con 12 piezas", "Presentación mayoreo (10 kg)"],
  "Unidad Equivalencia": ["Caja", "Kilogramo", "Pieza"],
  Venta: ["SI", "NO"],
  VentaOnline: ["SI", "NO"],
  Cliente: ["Distribuidora ABC SA de CV", "Juan Pérez (vacío = sin cliente asignado)"],
  Presentacion: ["Como la pide el cliente", "Caja cerrada de fábrica"],
  "Precio (nivel de precio)": ["199.99", "1500"],
};

const ejemplosParaColumna = (col) => {
  if (EJEMPLOS_POR_COLUMNA[col]) return EJEMPLOS_POR_COLUMNA[col];
  if (col.startsWith("Precio ")) return EJEMPLOS_POR_COLUMNA["Precio (nivel de precio)"];
  return [];
};

const PATRON_STRING = /^[A-Za-z0-9\n.: ,"'´`¨=ø$#°ºªáÁéÉíÍóÓúÚüÜñÑ@_/*+%&()!-_{¼³®™©Ø}–—“”‘’ ]*$/;

const boolStr = (v) => (v ? "SI" : "NO");
const boolVal = (v) => {
  const s = String(v).trim().toLowerCase();
  if (s === "si" || s === "sí") return true;
  if (s === "no") return false;
  return null;
};
const parseNumero = (val) => Number(String(val).replace(/\$\s?|(,*)/g, ""));

const aclararColor = (hex, factor) => {
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const mix = (c) => Math.round(c + (255 - c) * factor);
  const toHex = (c) => c.toString(16).padStart(2, "0").toUpperCase();
  return `${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
};

const BORDE_FINO = {
  top: { style: "thin", color: { rgb: "C0C0C0" } },
  bottom: { style: "thin", color: { rgb: "C0C0C0" } },
  left: { style: "thin", color: { rgb: "C0C0C0" } },
  right: { style: "thin", color: { rgb: "C0C0C0" } },
};
const estiloBannerGrupo = (color) => ({
  fill: { fgColor: { rgb: color } },
  font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center" },
  border: BORDE_FINO,
});
const estiloEncabezadoColumna = (color) => ({
  fill: { fgColor: { rgb: aclararColor(color, 0.75) } },
  font: { bold: true, sz: 10, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: BORDE_FINO,
});

const obtenerValorColumna = (eq, insumo, col, ctx) => {
  if (col === "ID") return eq ? encodeId(String(eq._id)) : "";
  if (col === "Clave Insumo Base") return insumo?.clave || "";
  if (col === "Descripcion Insumo Base") return insumo?.descripcion || "";
  if (col === "Unidad Insumo Base") return insumo?.unidadId?.nombre || "";
  if (col === "Factor") return eq?.equivalencia ?? "";

  if (col.startsWith("Precio ")) {
    const nombreNivel = col.replace(/^Precio /, "");
    const nivel = ctx.todasPrecios.find((p) => (p.nombre || "").trim() === nombreNivel);
    if (!nivel || !eq) return "";
    const p = (eq.precios || []).find((px) => String(px.precioId) === String(nivel._id));
    return p !== undefined ? p.precio : "";
  }

  if (!eq) return "";
  if (CAMPO_TEXTO[col] !== undefined) return eq[CAMPO_TEXTO[col]] || "";
  if (CAMPO_BOOL[col] !== undefined) return boolStr(eq[CAMPO_BOOL[col]]);

  const cat = CATALOGOS_CONFIG.find((c) => c.col === col);
  if (cat) return cat.getNombre(eq[cat.campo]) || "";

  return "";
};

const COLUMNAS_PREVIEW = [
  { title: "Clave", dataIndex: "clave", key: "clave", width: 140, sorter: true },
  { title: "Descripción", dataIndex: "descripcion", key: "descripcion", sorter: true },
  {
    title: "Familia",
    key: "familia",
    width: 180,
    render: (_, r) => r.familiaId?.nombre || "",
  },
  {
    title: "Tipo de Insumo",
    key: "tipoDeInsumo",
    width: 180,
    render: (_, r) => r.tipoDeInsumoId?.nombre || "",
  },
  {
    title: "Unidad",
    key: "unidad",
    width: 120,
    render: (_, r) => r.unidadId?.nombre || "",
  },
];

class EdicionMasivaEquivalencias extends Component {
  state = {
    loading: false,
    insumosMap: {},
    insumoPorClave: {},
    insumoPorDescripcion: {},
    equivalenciasMap: {},
    todasFamilias: [],
    todasUnidades: [],
    todosClientes: [],
    todasPrecios: [],
    todosTiposDeInsumo: [],
    filtrosExternos: { familiaIds: [], tipoDeInsumoIds: [] },
    previewIniciado: false,
    previewData: [],
    previewTotal: 0,
    previewLoading: false,
    archivosExcel: [],
    data: [],
    columnasPresentes: [],
    archivoError: null,
    errores: 0,
    soloConCambios: true,
    sinIdError: false,
    erroresBackend: [],
    guardando: false,
    progreso: { procesados: 0, total: null },
  };

  componentDidMount() {
    this.seguidor = new SeguidorProcesoMasivo({
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      onProgreso: (progreso) => this.setState({ guardando: true, progreso }),
      onFin: (resumen) => {
        this.setState({ guardando: false, progreso: { procesados: 0, total: null } });
        if (!resumen) return;
        const erroresBackend = resumen.errores || [];
        if (erroresBackend.length) {
          message.warning(
            `Se actualizaron ${resumen.numero ?? 0} equivalencia(s). Se omitieron ${erroresBackend.length} por errores.`
          );
          this.setState({ erroresBackend });
        } else {
          message.success(`Se actualizaron ${resumen.numero ?? 0} equivalencia(s)`);
          this.atras();
        }
      },
      onError: (error) => {
        this.setState({ guardando: false, progreso: { procesados: 0, total: null } });
        message.error(error || "Hubo un error al actualizar las equivalencias");
      },
    });
    this.seguidor.escuchar();

    this.setState({ loading: true });
    Promise.all([
      axios.post(
        "insumos/datosParaEdicionMasivaEquivalencias",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "insumos/datosParaImportar",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]).then(([resEquiv, resImportar]) => {
      this.setState({
        todosClientes: resEquiv.data.success === 2 ? resEquiv.data.clientes || [] : [],
        todasFamilias: resImportar.data.success === 2 ? resImportar.data.familias || [] : [],
        todasUnidades: resImportar.data.success === 2 ? resImportar.data.unidades || [] : [],
        todasPrecios: resImportar.data.success === 2 ? resImportar.data.precios || [] : [],
        todosTiposDeInsumo: resImportar.data.success === 2 ? resImportar.data.tiposDeInsumo || [] : [],
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    if (this.seguidor) this.seguidor.detener();
  }

  atras() {
    this.props.history.goBack();
  }

  consultarPreview(params) {
    if (!this.state.previewIniciado) {
      this.setState({ previewLoading: false });
      return;
    }
    this.setState({ previewLoading: true });
    axios
      .post(
        "insumos/insumosPreviewEdicionMasiva",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            previewData: res.data.data || [],
            previewTotal: res.data.totalRecords || 0,
            previewLoading: false,
          });
        } else {
          this.setState({ previewData: [], previewTotal: 0, previewLoading: false });
        }
      });
  }

  actualizarFiltrosPreview(cambios) {
    const filtrosExternos = { ...this.state.filtrosExternos, ...cambios };
    this.setState({ filtrosExternos, previewIniciado: true }, () => {
      if (this.tableRefPreview) this.tableRefPreview.updateExternalFilters(filtrosExternos);
    });
  }

  mostrarTodosPreview() {
    this.setState({ previewIniciado: true }, () => {
      if (this.tableRefPreview) this.tableRefPreview.updateExternalFilters(this.state.filtrosExternos);
    });
  }

  construirMapas(insumos) {
    const insumosMap = {};
    const insumoPorClave = {};
    const insumoPorDescripcion = {};
    const equivalenciasMap = {};
    insumos.forEach((ins) => {
      insumosMap[String(ins._id)] = ins;
      if (ins.clave) insumoPorClave[ins.clave] = ins;
      if (ins.descripcion) insumoPorDescripcion[ins.descripcion] = ins;
      (ins.equivalencias || []).forEach((eq) => {
        equivalenciasMap[String(eq._id)] = { ...eq, _insumoId: String(ins._id) };
      });
    });
    return { insumosMap, insumoPorClave, insumoPorDescripcion, equivalenciasMap };
  }

  descargarExcel() {
    const { filtrosExternos } = this.state;
    this.setState({ loading: true });
    axios
      .post(
        "insumos/insumosParaExportarEdicionMasivaEquivalencias",
        {
          empresaId: this.props.empresaId,
          familiaIds: filtrosExternos.familiaIds,
          tipoDeInsumoIds: filtrosExternos.tipoDeInsumoIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false });
          message.error("No se pudieron obtener los insumos a exportar");
          return;
        }
        const insumos = res.data.insumos || [];
        if (!insumos.length) {
          this.setState({ loading: false });
          message.warning("No hay insumos para descargar con los filtros seleccionados");
          return;
        }
        const { insumosMap, insumoPorClave, insumoPorDescripcion, equivalenciasMap } = this.construirMapas(insumos);
        this.setState({ insumosMap, insumoPorClave, insumoPorDescripcion, equivalenciasMap, loading: false }, () => {
          this.generarExcel(insumos);
        });
      });
  }

  generarExcel(insumos) {
    const { todasPrecios, todasUnidades, todosClientes } = this.state;

    const gruposActivos = GRUPOS
      .map((g) => ({ ...g, columnas: columnasDeGrupo(g, this.state) }))
      .filter((g) => g.columnas.length);

    const columnasOrdenadas = gruposActivos.flatMap((g) => g.columnas.map((col) => ({ col, grupo: g })));
    const ctx = { todasPrecios };

    const filas = insumos.flatMap((ins) => (ins.equivalencias || []).map((eq) => ({ eq, ins })));

    const filaGrupos = columnasOrdenadas.map(({ grupo }) => grupo.label);
    const filaColumnas = columnasOrdenadas.map(({ col }) => col);
    const filasDatos = filas.map(({ eq, ins }) =>
      columnasOrdenadas.map(({ col }) => obtenerValorColumna(eq, ins, col, ctx))
    );

    const ws = XLSX.utils.aoa_to_sheet([filaGrupos, filaColumnas, ...filasDatos]);

    const merges = [];
    let inicio = 0;
    for (let i = 1; i <= columnasOrdenadas.length; i++) {
      if (i === columnasOrdenadas.length || columnasOrdenadas[i].grupo.key !== columnasOrdenadas[inicio].grupo.key) {
        if (i - 1 > inicio) merges.push({ s: { r: 0, c: inicio }, e: { r: 0, c: i - 1 } });
        inicio = i;
      }
    }
    ws["!merges"] = merges;

    columnasOrdenadas.forEach(({ grupo }, idx) => {
      const cellGrupo = XLSX.utils.encode_cell({ r: 0, c: idx });
      const cellCol = XLSX.utils.encode_cell({ r: 1, c: idx });
      if (ws[cellGrupo]) ws[cellGrupo].s = estiloBannerGrupo(grupo.color);
      if (ws[cellCol]) ws[cellCol].s = estiloEncabezadoColumna(grupo.color);
    });

    ws["!cols"] = filaColumnas.map((h) => ({ wch: Math.max(h.length + 2, 15) }));
    ws["!rows"] = [{ hpt: 22 }, { hpt: 26 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Equivalencias");

    const instrucciones = [
      ["Instrucciones de uso"],
      [""],
      ["1. La columna ID es OBLIGATORIA y NO debe modificarse ni eliminarse. Va vacía en las filas que usted agregue para dar de alta una equivalencia nueva."],
      ["2. En filas NUEVAS (ID vacío), llene Clave Insumo Base O Descripcion Insumo Base para indicar a qué insumo pertenece la equivalencia (vea la hoja \"Catalogo Insumos\"); si llena ambas se usa la Clave. Es obligatorio solo en filas nuevas."],
      ["3. Las primeras dos filas son encabezados: la fila 1 agrupa las columnas por sección, la fila 2 trae el nombre real de cada columna. No borre ninguna de las dos filas."],
      ["4. Para AGREGAR una equivalencia nueva: agregue una fila al final, deje la columna ID vacía, y llene al menos Clave/Descripcion Insumo Base, Descripcion Equivalencia, Unidad Equivalencia, Factor y Venta."],
      ["5. Para EDITAR una equivalencia existente: modifique los valores de su fila sin tocar la columna ID."],
      ["6. Columnas SI/NO: use SI o NO."],
      ["7. Clave Insumo Base, Descripcion Insumo Base y Unidad Insumo Base son meramente informativas: no se guardan y no impiden guardar sus ediciones. En filas EXISTENTES (con ID) se ignoran por completo: el insumo dueño ya lo determina el ID, sin importar lo que haya escrito ahí."],
      ["8. Unidad Equivalencia: escriba exactamente el nombre tal como aparece en la hoja \"Catalogo Unidad\"."],
      ["9. Cliente: opcional. Escriba el nombre completo o razón social exacto tal como aparece en la hoja \"Catalogo Cliente\". Deje vacío para quitar el cliente asignado."],
      ["10. Revise la hoja \"Ejemplos\" para ver el tipo de dato esperado en cada columna."],
    ];
    const wsInstr = XLSX.utils.aoa_to_sheet(instrucciones);
    wsInstr["!cols"] = [{ wch: 100 }];
    XLSX.utils.book_append_sheet(wb, wsInstr, "Instrucciones");

    const aoaEjemplos = [["Grupo", "Columna", "Ejemplo 1", "Ejemplo 2"]];
    columnasOrdenadas.forEach(({ col, grupo }) => {
      const ejemplos = ejemplosParaColumna(col);
      aoaEjemplos.push([grupo.label, col, ejemplos[0] || "", ejemplos[1] || ""]);
    });
    const wsEjemplos = XLSX.utils.aoa_to_sheet(aoaEjemplos);
    wsEjemplos["!cols"] = [{ wch: 20 }, { wch: 22 }, { wch: 35 }, { wch: 35 }];
    for (let c = 0; c < 4; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c });
      if (wsEjemplos[cellRef]) wsEjemplos[cellRef].s = estiloBannerGrupo("595959");
    }
    columnasOrdenadas.forEach(({ grupo }, idx) => {
      const cellGrupo = XLSX.utils.encode_cell({ r: idx + 1, c: 0 });
      if (wsEjemplos[cellGrupo]) {
        wsEjemplos[cellGrupo].s = {
          fill: { fgColor: { rgb: aclararColor(grupo.color, 0.75) } },
          font: { bold: true, sz: 10, name: "Arial" },
        };
      }
    });
    XLSX.utils.book_append_sheet(wb, wsEjemplos, "Ejemplos");

    const aoaInsumos = [
      ["Clave", "Descripcion", "Unidad"],
      ...insumos.map((ins) => [ins.clave || "", ins.descripcion || "", ins.unidadId?.nombre || ""]),
    ];
    const wsInsumos = XLSX.utils.aoa_to_sheet(aoaInsumos);
    wsInsumos["!cols"] = [{ wch: 20 }, { wch: 50 }, { wch: 20 }];
    XLSX.utils.book_append_sheet(wb, wsInsumos, "Catalogo Insumos");

    if (todasUnidades.length) {
      const wsUnidad = XLSX.utils.aoa_to_sheet([["Nombre"], ...todasUnidades.map((u) => [u.nombre || ""])]);
      wsUnidad["!cols"] = [{ wch: 30 }];
      XLSX.utils.book_append_sheet(wb, wsUnidad, "Catalogo Unidad");
    }

    if (todosClientes.length) {
      const wsCliente = XLSX.utils.aoa_to_sheet([["Nombre"], ...todosClientes.map((c) => [nombreCliente(c)])]);
      wsCliente["!cols"] = [{ wch: 40 }];
      XLSX.utils.book_append_sheet(wb, wsCliente, "Catalogo Cliente");
    }

    XLSX.writeFile(wb, "edicion_masiva_equivalencias.xlsx");
  }

  onChangeArchivo(e) {
    this.setState({ loading: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }],
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de Excel (.xlsx)");
      this.setState({ loading: false });
    }
  }

  cargarArchivoExcel(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const primeraHoja = workbook.SheetNames[0];
      const filas = XLSX.utils.sheet_to_json(
        workbook.Sheets[primeraHoja],
        { defval: "", range: 1 }
      );
      this.asegurarMapas(filas)
        .then(() => this.procesarFilas(filas))
        .then((result) => {
          this.setState({
            data: result.data,
            columnasPresentes: result.columnasPresentes,
            errores: result.errores,
            archivoError: result.errores > 0 ? result.archivoErrores : null,
            sinIdError: result.sinIdError,
            archivosExcel: [{ ...file, name: file.name, status: "success" }],
            loading: false,
            erroresBackend: [],
          });
          if (result.sinIdError) {
            message.error(
              "El archivo no contiene las columnas ID y Clave Insumo Base. Descargue el Excel desde este módulo e intente nuevamente."
            );
          } else if (result.errores > 0) {
            message.warning(
              `Se detectaron ${result.errores} errores. Descargue el archivo de errores para revisarlos.`
            );
          } else {
            const conCambios = result.data.filter((d) => d._hayCambios).length;
            message.success(
              `Archivo leído: ${conCambios} equivalencia(s) con cambios de ${result.data.length} leídas.`
            );
          }
        });
    };
  }

  asegurarMapas(filas) {
    const { equivalenciasMap, insumoPorClave, insumoPorDescripcion } = this.state;

    const faltaAlguno = filas.some((fila) => {
      const encodedId = String(fila["ID"] || "").trim();
      if (encodedId) {
        const decodedId = decodeId(encodedId);
        if (!decodedId || !Object.prototype.hasOwnProperty.call(equivalenciasMap, decodedId)) return true;
      }
      const claveInsumo = String(fila["Clave Insumo Base"] || "").trim();
      if (claveInsumo && !Object.prototype.hasOwnProperty.call(insumoPorClave, claveInsumo)) return true;
      if (!claveInsumo) {
        const descInsumo = String(fila["Descripcion Insumo Base"] || "").trim();
        if (descInsumo && !Object.prototype.hasOwnProperty.call(insumoPorDescripcion, descInsumo)) return true;
      }
      return false;
    });

    if (!faltaAlguno) return Promise.resolve();

    return axios
      .post(
        "insumos/insumosParaExportarEdicionMasivaEquivalencias",
        { empresaId: this.props.empresaId, familiaIds: [], tipoDeInsumoIds: [] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error("No se pudieron obtener los insumos para validar el archivo");
          return;
        }
        const { insumosMap, insumoPorClave, insumoPorDescripcion, equivalenciasMap } = this.construirMapas(res.data.insumos || []);
        return new Promise((resolve) => {
          this.setState({ insumosMap, insumoPorClave, insumoPorDescripcion, equivalenciasMap }, resolve);
        });
      })
      .catch(() => {
        message.error("No se pudieron obtener los insumos para validar el archivo");
      });
  }

  async procesarFilas(filas) {
    if (!filas.length) {
      return { data: [], columnasPresentes: [], errores: 0, sinIdError: false, archivoErrores: null };
    }

    const { insumosMap, equivalenciasMap, insumoPorClave, insumoPorDescripcion, todasUnidades, todosClientes, todasPrecios } = this.state;

    const primeraFila = filas[0];
    if (!("ID" in primeraFila) || !("Clave Insumo Base" in primeraFila)) {
      return { data: [], columnasPresentes: [], errores: 0, sinIdError: true, archivoErrores: null };
    }

    const precioColumnas = todasPrecios
      .map((p) => `Precio ${(p.nombre || "").trim()}`)
      .filter((c) => c !== "Precio ");
    const TODAS_EDITABLES = [...COLUMNAS_FIJAS.filter((c) => c !== "ID"), ...precioColumnas];
    const columnasPresentes = TODAS_EDITABLES.filter((col) => col in primeraFila);

    const catalogos = { todasUnidades, todosClientes };

    const erroresRows = [];
    const data = [];
    let errores = 0;

    for (const fila of filas) {
      const encodedId = String(fila["ID"] || "").trim();
      const decodedId = encodedId ? decodeId(encodedId) : null;
      const eq = decodedId ? equivalenciasMap[decodedId] : null;
      const esNueva = !encodedId;

      if (encodedId && !eq) {
        errores++;
        erroresRows.push({ ...fila, Errores: `ID no encontrado: ${encodedId}` });
        continue;
      }

      // Para filas existentes el ID ya identifica sin ambigüedad la equivalencia y su insumo
      // dueño: Clave/Descripcion Insumo Base son meramente informativas ahí y NUNCA deben
      // bloquear una edición (aunque el usuario las haya tocado o no coincidan más).
      // Solo se usan para resolver el insumo cuando la fila es nueva (sin ID).
      let insumoResuelto;
      if (esNueva) {
        const claveInsumo = String(fila["Clave Insumo Base"] || "").trim();
        const descInsumoBase = String(fila["Descripcion Insumo Base"] || "").trim();
        if (!claveInsumo && !descInsumoBase) {
          errores++;
          erroresRows.push({ ...fila, Errores: "Clave Insumo Base o Descripcion Insumo Base: no puede estar vacío" });
          continue;
        }
        insumoResuelto = claveInsumo ? insumoPorClave[claveInsumo] : insumoPorDescripcion[descInsumoBase];
        if (!insumoResuelto) {
          errores++;
          erroresRows.push({ ...fila, Errores: `Insumo: "${claveInsumo || descInsumoBase}" no encontrado` });
          continue;
        }
      } else {
        insumoResuelto = insumosMap[String(eq._insumoId)];
        if (!insumoResuelto) {
          errores++;
          erroresRows.push({ ...fila, Errores: `No se encontró el insumo dueño de la equivalencia (ID: ${encodedId})` });
          continue;
        }
      }

      const actual = eq || {};
      const obj = {
        insumoId: String(insumoResuelto._id),
        _insumoClave: insumoResuelto.clave,
        _esNueva: esNueva,
      };
      if (!esNueva) obj.equivalenciaId = String(eq._id);

      const cambios = [];
      const filaErrores = [];
      let nuevosPreciosParciales = {};
      let tocaPreciosFila = false;

      for (const col of columnasPresentes) {
        if (col === "Clave Insumo Base") {
          obj["_d_Clave Insumo Base"] = insumoResuelto.clave || "";
          continue;
        }
        if (col === "Descripcion Insumo Base") {
          obj["_d_Descripcion Insumo Base"] = insumoResuelto.descripcion || "";
          continue;
        }
        if (col === "Unidad Insumo Base") {
          obj["_d_Unidad Insumo Base"] = insumoResuelto.unidadId?.nombre || "";
          continue;
        }

        const val = String(fila[col] ?? "").trim();

        if (COLS_REQUERIDAS.has(col) && !val) {
          filaErrores.push(`${col}: no puede estar vacío`);
          continue;
        }

        if (col === "Factor") {
          if (val === "") continue;
          const num = parseNumero(val);
          if (isNaN(num)) {
            filaErrores.push(`Factor: "${val}" no es un número`);
            continue;
          }
          obj.equivalencia = num;
          obj["_d_Factor"] = String(num);
          if (String(actual.equivalencia ?? "") !== String(num)) cambios.push(col);
        } else if (precioColumnas.includes(col)) {
          tocaPreciosFila = true;
          const nombreNivel = col.replace(/^Precio /, "");
          const nivel = todasPrecios.find((p) => (p.nombre || "").trim() === nombreNivel);
          if (!nivel) continue;
          if (val !== "") {
            const num = parseNumero(val);
            if (isNaN(num)) {
              filaErrores.push(`${col}: "${val}" no es un número`);
              continue;
            }
            nuevosPreciosParciales[String(nivel._id)] = num;
          }
        } else if (CAMPO_TEXTO[col] !== undefined) {
          const campo = CAMPO_TEXTO[col];
          if (val && !PATRON_STRING.test(val)) {
            filaErrores.push(`${col}: contiene caracteres no aceptados`);
            continue;
          }
          obj[campo] = val;
          obj[`_d_${col}`] = val;
          if (String(actual[campo] || "") !== val) cambios.push(col);
        } else if (CAMPO_BOOL[col] !== undefined) {
          const campo = CAMPO_BOOL[col];
          const bv = boolVal(val);
          if (bv === null) {
            filaErrores.push(`${col}: valor inválido "${val}" (use SI o NO)`);
            continue;
          }
          obj[campo] = bv;
          obj[`_d_${col}`] = bv ? "SI" : "NO";
          if (bv !== !!actual[campo]) cambios.push(col);
        } else {
          const cfg = CATALOGOS_CONFIG.find((c) => c.col === col);
          if (!cfg) continue;
          const lista = catalogos[cfg.stateKey] || [];
          if (val === "") {
            obj[cfg.campo] = null;
            obj[`_d_${col}`] = "";
            if (actual[cfg.campo]) cambios.push(col);
            continue;
          }
          const encontrado = lista.find((item) => String(cfg.getNombre(item) ?? "").trim() === val);
          if (!encontrado) {
            filaErrores.push(`${col}: "${val}" no encontrado`);
            continue;
          }
          obj[cfg.campo] = encontrado._id;
          obj[`_d_${col}`] = val;
          const idActual = String(actual[cfg.campo]?._id || actual[cfg.campo] || "");
          if (idActual !== String(encontrado._id)) cambios.push(col);
        }
      }

      if (tocaPreciosFila) {
        const preciosArr = Object.entries(nuevosPreciosParciales).map(([precioId, precio]) => ({ precioId, precio }));
        obj.precios = preciosArr;
        for (const [precioId, precio] of Object.entries(nuevosPreciosParciales)) {
          const nivel = todasPrecios.find((p) => String(p._id) === precioId);
          if (!nivel) continue;
          const colNombre = `Precio ${(nivel.nombre || "").trim()}`;
          obj[`_d_${colNombre}`] = `$${precio}`;
          const actualP = (actual.precios || []).find((p) => String(p.precioId) === precioId);
          if (!actualP || String(actualP.precio) !== String(precio)) cambios.push(colNombre);
        }
      }

      if (filaErrores.length) {
        errores++;
        erroresRows.push({ ...fila, Errores: filaErrores.join("; ") });
        continue;
      }

      obj._cambios = cambios;
      obj._hayCambios = esNueva ? true : cambios.length > 0;
      obj._claveOriginal = actual.descripcion || (esNueva ? "(nueva)" : "");
      obj._rowKey = eq ? String(eq._id) : `nueva-${data.length}`;
      data.push(obj);
    }

    const archivoEditar = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(archivoEditar, XLSX.utils.json_to_sheet(erroresRows), "Errores");
    return {
      data,
      columnasPresentes,
      errores,
      sinIdError: false,
      archivoErrores: archivoEditar,
    };
  }

  descargarArchivoErrores() {
    if (!this.state.archivoError) return;
    const wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores_edicion_masiva_equivalencias.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onFinish() {
    const dataConCambios = this.state.data.filter((d) => d._hayCambios);
    if (!dataConCambios.length) {
      message.warning("No hay cambios que guardar");
      return;
    }
    const dataParaEnviar = dataConCambios.map((row) => {
      const obj = {};
      for (const key in row) {
        if (
          !key.startsWith("_d_") &&
          !["_cambios", "_hayCambios", "_claveOriginal", "_insumoClave", "_rowKey"].includes(key)
        ) {
          obj[key] = row[key];
        }
      }
      return obj;
    });

    const columnasParaEnviar = [...this.state.columnasPresentes];

    this.setState({ loading: true, erroresBackend: [] });
    axios
      .post(
        "insumos/editarEquivalenciasMasivo",
        {
          empresaId: this.props.empresaId,
          data: dataParaEnviar,
          columnas: columnasParaEnviar,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          if (res.data.success === 1) {
            message.error("No se pudieron actualizar las equivalencias");
          } else {
            message.error(res.data.message || "Hubo un error al actualizar las equivalencias");
          }
          return;
        }

        if (res.data.total === 0) {
          this.setState({ erroresBackend: res.data.errores || [] });
          message.warning(`No hubo equivalencias que actualizar. Se omitieron ${(res.data.errores || []).length}.`);
          return;
        }

        this.setState({
          guardando: true,
          progreso: { procesados: 0, total: res.data.total ?? null },
        });
        this.seguidor.seguir(res.data.procesoId);
      });
  }

  render() {
    const {
      data,
      columnasPresentes,
      errores,
      sinIdError,
      soloConCambios,
      erroresBackend,
    } = this.state;

    const totalConCambios = data.filter((d) => d._hayCambios).length;
    const dataMostrar = soloConCambios ? data.filter((d) => d._hayCambios) : data;

    const columnasClave = [
      {
        title: "Insumo Base / Equivalencia",
        dataIndex: "_claveOriginal",
        key: "_claveOriginal",
        fixed: "left",
        width: 200,
        render: (v, r) => `${r._insumoClave || ""} — ${v}`,
      },
    ];

    const renderCelda = (col, grupo) => (_, record) => {
      const val = record[`_d_${col}`] ?? String(record[col] ?? "");
      const changed = record._cambios && record._cambios.includes(col);
      const colorGrupo = grupo?.color;
      return (
        <span
          style={{
            backgroundColor: changed ? (colorGrupo ? `#${aclararColor(colorGrupo, 0.72)}` : "#fff3cd") : undefined,
            borderLeft: changed && colorGrupo ? `3px solid #${colorGrupo}` : undefined,
            padding: changed ? "2px 6px" : undefined,
            borderRadius: changed ? 4 : undefined,
            display: "inline-block",
          }}
        >
          {val}
        </span>
      );
    };

    const columnasOrdenadas = columnasPresentes
      .map((col) => ({ col, grupo: grupoDeColumna(col, this.state) }))
      .sort((a, b) => {
        const ia = a.grupo ? GRUPOS.indexOf(a.grupo) : GRUPOS.length;
        const ib = b.grupo ? GRUPOS.indexOf(b.grupo) : GRUPOS.length;
        return ia - ib;
      });

    const columnasTabla = columnasOrdenadas.map(({ col, grupo }) => ({
      title: col,
      key: col,
      width: 150,
      onHeaderCell: () =>
        grupo ? { style: { backgroundColor: `#${aclararColor(grupo.color, 0.85)}` } } : {},
      render: renderCelda(col, grupo),
    }));

    const columns = [...columnasClave, ...columnasTabla];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Edición Masiva de Equivalencias de Insumo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor...">
            <Alert
              style={{ marginBottom: 16, marginTop: 10 }}
              type="info"
              showIcon
              message="Instrucciones"
              description={
                <ol style={{ margin: 0, paddingLeft: 20 }}>
                  <li>
                    Filtre por Familia y/o Tipo de Insumo (opcional) para acotar qué
                    insumos va a exportar. Revise la vista previa antes de descargar.
                  </li>
                  <li>Descargue el Excel: trae una fila por cada equivalencia existente.</li>
                  <li>
                    Edite las filas que necesite, o agregue filas nuevas al final
                    (columna <b>ID</b> vacía) para dar de alta equivalencias.
                  </li>
                  <li>
                    La columna <b>ID</b> no debe modificarse en las filas existentes. En
                    filas <b>nuevas</b> (ID vacío) debe llenar <b>Clave Insumo Base</b> o{" "}
                    <b>Descripcion Insumo Base</b> para identificar el insumo (si llena
                    ambas, se usa la clave); en filas existentes esas columnas son solo
                    informativas y no afectan el guardado.
                  </li>
                  <li>
                    Suba el archivo modificado y revise la vista previa antes de
                    guardar.
                  </li>
                </ol>
              }
            />
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>
                Filtra qué insumos vas a exportar (opcional)
              </div>
              <Row gutter={12}>
                <Col span={12}>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Filtrar por Familia"
                    style={{ width: "100%" }}
                    value={this.state.filtrosExternos.familiaIds}
                    onChange={(vals) => this.actualizarFiltrosPreview({ familiaIds: vals })}
                    options={this.state.todasFamilias.map((f) => ({ label: f.nombre, value: f._id }))}
                    optionFilterProp="label"
                  />
                </Col>
                <Col span={12}>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Filtrar por Tipo de Insumo"
                    style={{ width: "100%" }}
                    value={this.state.filtrosExternos.tipoDeInsumoIds}
                    onChange={(vals) => this.actualizarFiltrosPreview({ tipoDeInsumoIds: vals })}
                    options={this.state.todosTiposDeInsumo.map((t) => ({ label: t.nombre, value: t._id }))}
                    optionFilterProp="label"
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>
                Vista previa de qué insumos se van a exportar
                {this.state.previewIniciado &&
                  ` (${this.state.previewTotal} insumo${this.state.previewTotal !== 1 ? "s" : ""})`}
              </div>
              {this.state.previewIniciado ? (
                <TableItemDinamico
                  ref={(ref) => {
                    this.tableRefPreview = ref;
                  }}
                  onRef={(ref) => {
                    this.tableRefPreview = ref;
                  }}
                  size="small"
                  columns={COLUMNAS_PREVIEW}
                  dataSource={this.state.previewData}
                  totalRecords={this.state.previewTotal}
                  loading={this.state.previewLoading}
                  pagination={false}
                  rowKey="_id"
                  onFetchData={this.consultarPreview.bind(this)}
                />
              ) : (
                <Alert
                  type="info"
                  showIcon
                  message="Elige un filtro de Familia o Tipo de Insumo arriba, o muestra todos los insumos para ver la vista previa."
                  action={
                    <ButtonItem size="small" onClick={this.mostrarTodosPreview.bind(this)}>
                      Mostrar todos
                    </ButtonItem>
                  }
                />
              )}
            </div>
            <Row style={{ marginBottom: 16, alignItems: "center" }}>
              <Col span={12}>
                <ButtonItem
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={this.descargarExcel.bind(this)}
                >
                  Descargar Excel
                </ButtonItem>
              </Col>
              <Col span={12}>
                <Upload
                  showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                  fileList={this.state.archivosExcel}
                  customRequest={this.onChangeArchivo.bind(this)}
                  accept=".xlsx"
                >
                  <ButtonItem icon={<UploadOutlined />}>
                    Subir Excel modificado
                  </ButtonItem>
                </Upload>
              </Col>
            </Row>

            {sinIdError && (
              <Alert
                type="error"
                showIcon
                message="El archivo no contiene las columnas ID y Clave Insumo Base. Descargue el Excel desde este módulo y vuelva a intentarlo."
                style={{ marginBottom: 16 }}
              />
            )}

            {data.length > 0 && !sinIdError && (
              <>
                <Alert
                  type={errores > 0 ? "warning" : "success"}
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={
                    <>
                      Se detectaron <b>{totalConCambios}</b> equivalencia(s) con
                      cambios o altas en las columnas:{" "}
                      <b>{columnasPresentes.join(", ")}</b>.
                      {errores > 0 && (
                        <>
                          {" "}Se omitieron <b>{errores}</b> fila(s) con
                          errores.
                        </>
                      )}
                    </>
                  }
                />
                {erroresBackend && erroresBackend.length > 0 && (
                  <Alert
                    type="error"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message={`El backend rechazó ${erroresBackend.length} fila(s):`}
                    description={
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {erroresBackend.map((e, idx) => {
                          const ins = this.state.insumosMap[String(e.insumoId)];
                          const clave = ins?.clave || e.insumoId;
                          return (
                            <li key={idx}>
                              <b>{clave}</b>: {e.motivo}
                            </li>
                          );
                        })}
                      </ul>
                    }
                  />
                )}
                <div
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <Switch
                      checked={soloConCambios}
                      onChange={(v) => this.setState({ soloConCambios: v })}
                      size="small"
                    />{" "}
                    Mostrar solo con cambios ({totalConCambios} de {data.length})
                  </span>
                  {totalConCambios > 0 && (
                    <ButtonItem
                      type="primary"
                      onClick={this.onFinish.bind(this)}
                    >
                      Guardar cambios en {totalConCambios} equivalencia
                      {totalConCambios !== 1 ? "s" : ""}
                    </ButtonItem>
                  )}
                </div>
                <TableItem
                  size="small"
                  dataSource={dataMostrar}
                  columns={columns}
                  scroll={{ x: "max-content" }}
                  rowKey="_rowKey"
                />
              </>
            )}
          </Spin>
        </div>
        <ModalProgreso
          visible={this.state.guardando}
          titulo="Guardando cambios"
          descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Las equivalencias se escriben por lotes para no saturar la base."
          procesados={this.state.progreso.procesados}
          total={this.state.progreso.total}
          unidad="insumos"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EdicionMasivaEquivalencias);
